<template>
  <MenuButton as="template">
    <button :class="classes">
      {{ props.label }}
      <ChevronDownIcon
        class="-mr-1 ml-2"
        :class="iconSize"
        aria-hidden="true"
      />
    </button>
  </MenuButton>
</template>

<script setup>
import { MenuButton } from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/solid'
import { computed } from 'vue'
import { useButtonClasses } from '../Buttons/common'
import { iconSizeClasses } from '../common'

const props = defineProps({
  label: {
    type: String,
    default: 'Options',
  },
  size: {
    type: String,
    default: 'md',
  },
  color: {
    type: String,
    default: 'white',
  },
  shape: {
    type: String,
    default: 'default',
  },
})

const classes = useButtonClasses(props)

function buttonSizeToIconSizeMap(buttonSize) {
  return {
    xs: 'sm',
    sm: 'sm',
    md: 'md',
    lg: 'md',
    xl: 'md',
  }[buttonSize]
}

const iconSize = computed(() =>
  iconSizeClasses(buttonSizeToIconSizeMap(props.size))
)
</script>
